import React from 'react';
import { Header } from 'semantic-ui-react';
import { useUserContext } from '~/hooks';

const ContactCard: React.FC = (props) => {

    const { loggedInUser } = useUserContext();

    const owner = loggedInUser?.companyOwner;

    const ownerInfo = {
        'Marc Palmer': {
            photo: require('~/assets/team/marc-palmer.webp'),
            phone: '(937) 541-1121',
        },
        'Aaron James': {
            photo: require('~/assets/team/aaron-james.webp'),
            phone: '(413) 247-4578',
        },
        'James Coombes': {
            photo: require('~/assets/team/james-coombes.webp'),
            phone: '(415) 517-5565',
        }
    };

    const contact = ownerInfo[owner?.name as keyof typeof ownerInfo];

    return (
        <div className="card">
            <Header as="h2">Contact Conductor</Header>
            {contact ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginTop: '12px', marginBottom: '10px' }}>
                    {contact.photo &&
                        <img
                            src={contact.photo}
                            alt={owner?.name}
                            style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover' }}
                        />
                    }
                    <div>
                        <Header as="h3" style={{ marginBottom: '0px', fontSize: '16px'}}>{owner?.name}</Header>
                        <div>
                            <a href={`mailto:${owner?.email}`} style={{ marginBottom: '0px', fontSize: '14px'}}>{owner?.email}</a>
                        </div>
                        <div>
                            <a href={`tel:${contact.phone}`} style={{ marginBottom: '0px', fontSize: '14px'}}>{contact.phone}</a>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ marginTop: '1rem' }}>No contact information available.</div>
            )}
        </div>
    );
};

export default ContactCard;